import { ToolSystem } from "../../../base/ToolSystem";

// File tools
import {
  CreateFolderTool,
  DeleteFileTool,
  DuplicateFileTool,
  ExportFilesTool,
  ImportFilesTool,
  GrepFileTool,
  ListDirectoryTool,
  MoveFileTool,
  ReadFileTool,
  RenameFileTool,
  UploadFilesTool,
  UploadFolderTool,
  WriteFileTool,
} from "../implementations/file/index.js";

// Sync tools
import { SyncFromCloudTool, SyncToCloudTool } from "../implementations/sync/index.js";

// Editor tools
import { CloseTabTool } from "../implementations/editor/index.js";

// App tools
import { EntryFilePathTool } from "../implementations/app/index.js";

// Git tools
import {
  GitCheckoutTool,
  GitCommitTool,
  GitDiffTool,
  GitDiscardTool,
  GitInitTool,
  GitLogTool,
  GitStageTool,
  GitStatusTool,
  GitUnstageTool,
} from "../implementations/git/index.js";

// Search tools
import { WebSearchTool } from "../implementations/search/index.js";

// Agent entries (numbered /agents/agent-entry-NNN.md + README index)
import { AgentEntriesTool } from "../implementations/agents/index.js";

// Local workspace: one-shot shell commands (Revolt Desktop)
import { ShellTool } from "../implementations/shell/index.js";

export class WorkspaceToolSystem extends ToolSystem {
  constructor() {
    super();
    this.appType = null;
    this.fs = null; // Filesystem reference (Lightning FS for browser apps)
    this.git = null; // Git reference (isomorphic-git for browser apps)
    this.workspaceManager = null; // Reference to WorkspaceManager (for UI sync)

    // Register all file tools
    this.registerTool(CreateFolderTool);
    this.registerTool(ReadFileTool);
    this.registerTool(WriteFileTool);
    this.registerTool(ListDirectoryTool);
    this.registerTool(DeleteFileTool);
    this.registerTool(MoveFileTool);
    this.registerTool(RenameFileTool);
    this.registerTool(DuplicateFileTool);
    this.registerTool(ExportFilesTool);
    this.registerTool(ImportFilesTool);
    this.registerTool(GrepFileTool);
    this.registerTool(UploadFilesTool);
    this.registerTool(UploadFolderTool);

    // Register all sync tools
    this.registerTool(SyncFromCloudTool);
    this.registerTool(SyncToCloudTool);

    // Register all editor tools
    this.registerTool(CloseTabTool);

    // Register all app tools
    this.registerTool(EntryFilePathTool);

    // Register all git tools
    this.registerTool(GitInitTool);
    this.registerTool(GitCheckoutTool);
    this.registerTool(GitDiffTool);
    this.registerTool(GitStatusTool);
    this.registerTool(GitStageTool);
    this.registerTool(GitUnstageTool);
    this.registerTool(GitCommitTool);
    this.registerTool(GitDiscardTool);
    this.registerTool(GitLogTool);

    // Register all search tools
    this.registerTool(WebSearchTool);

    // Agent entry tools (project agents folder)
    this.registerTool(AgentEntriesTool);

    // Shell (local app + Revolt Desktop only)
    this.registerTool(ShellTool);

  }

  /**
   * Set the workspace manager reference
   * @param {WorkspaceManager} workspaceManager - The workspace manager instance
   */
  setWorkspaceManager(workspaceManager) {
    this.workspaceManager = workspaceManager;
  }
}
